import React from 'react'
import { Navigate } from 'react-router-dom'
import { useCapitalActivePayoutsAccess } from '../../../hooks/useCapitalActivePayoutsAccess'

interface DefaultPayoutsRedirectGuardProps {
	children: React.ReactNode
}

const DefaultPayoutsRedirectGuard = ({
	children
}: DefaultPayoutsRedirectGuardProps): JSX.Element => {
	const { canAccess } = useCapitalActivePayoutsAccess()

	if (!canAccess) {
		return <Navigate to="/dashboard/payouts-v2" replace />
	}

	return <>{children}</>
}

export default DefaultPayoutsRedirectGuard
